import type { MessageDescriptor } from "react-intl";

import { COMMON_MESSAGES } from "../../../components/common-messages";
import type { FundingApplicationDocumentType } from "../../../types";

export const DOC_TYPE_TO_NAME: Record<FundingApplicationDocumentType, MessageDescriptor> = {
  susa: COMMON_MESSAGES.documentUploadSusa,
  "pool-bancario": COMMON_MESSAGES.documentUploadPoolBancario,
  "cash-flow-forecast": COMMON_MESSAGES.documentUploadRevenueForecast,
  "debt-agreement": COMMON_MESSAGES.documentUploadDebtAgreement,
  "profit-and-loss": COMMON_MESSAGES.documentUploadProfitAndLoss,
  "balance-sheet": COMMON_MESSAGES.documentUploadBalanceSheet,
  "management-accounts": COMMON_MESSAGES.documentUploadManagementAccounts,
  "purchase-order": COMMON_MESSAGES.documentUploadPurchaseOrder,
};
